import { useRef } from 'react';

import { Box } from 'components/Box';
import { Hide } from 'components/Hide';
import { colors, gutterWidth } from 'theme/theme';

import { StaffMobileSearchMenu } from './StaffMobileSearchMenu';
import { StaffPageHeaderSearchInputs } from './StaffPageHeaderSearchInputs';
import { useStaffSearchMenu } from './useStaffSearchMenu';

type Props = {
  searchOpen: boolean;
  toggleSearch: (searchOpen: boolean) => void;
};

export function StaffPageHeaderSearchMenu({ searchOpen, toggleSearch }: Props) {
  const staffProps = useStaffSearchMenu();
  const initialQuery = useRef(staffProps.query).current;

  return (
    <>
      <StaffMobileSearchMenu
        onClose={() => toggleSearch(false)}
        onSearch={() => toggleSearch(false)}
        searchOpen={searchOpen}
        selectedType={staffProps.selectedType}
        listingTypes={staffProps.listingTypes}
        clearSearchInput={staffProps.clearSearchInput}
        search={staffProps.search}
        initialQuery={initialQuery}
        query={staffProps.query}
        searchLocation={staffProps.searchLocation || undefined}
        setListingType={staffProps.setListingType}
        setUserQuery={staffProps.setQuery}
        onLocationChange={staffProps.onLocationChange}
      />

      <Hide xs sm md>
        <Box
          data-qa-id="staff-search-menu"
          classes={['flex', 'align-center']}
          position="relative"
          width="100%"
          bg="white"
          pb={['36px', null, null, 16]}
          pt={['36px', null, null, 16]}
          px={gutterWidth / 2}
          height="100%"
          borderTop={`1px solid ${colors.inputGrey}`}
        >
          <Box flex="1 1 auto" width="100%" height="100%">
            <StaffPageHeaderSearchInputs
              selectedType={staffProps.selectedType}
              listingTypes={staffProps.listingTypes}
              clearSearchInput={staffProps.clearSearchInput}
              search={staffProps.search}
              initialQuery={initialQuery}
              query={staffProps.query}
              searchLocation={staffProps.searchLocation}
              setListingType={staffProps.setListingType}
              setQuery={staffProps.setQuery}
              onLocationChange={staffProps.onLocationChange}
              searchInputId="search-query"
              searchInputQaId="search-input"
            />
          </Box>
        </Box>
      </Hide>
    </>
  );
}
